/** @format */

import React from "react"
import { useTable, useSortBy } from "react-table"
import { SortRegular, SortUpRegular } from "@ui-library/icons"
import { Icon } from "@ui-library/core"
import { LabelContainer, TableContainer } from "./Table.styled"

export const Table = (props: any) => {
	const {
		columns,
		data,
		rowProps,
		initialState,
		isLoading
	} = props
	const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
		useTable({ columns, data, initialState }, useSortBy)

	let rowUniqKey = 0
	let cellUniqKey = 0

	return (
		<TableContainer>
			<table {...getTableProps()}>
				<thead>
					{headerGroups.map(headerGroup => (
						<tr
							key={`headerGroup-${headerGroup.id}`}
							{...headerGroup.getHeaderGroupProps()}
						>
							{headerGroup.headers.map((column: any, index) => {
								const isSortable =
									!column.isSorted && !column.disableSortBy ? "sortable" : ""
								const isSorted = column.isSorted ? "sorted" : ""
								const additionalClasses = column.className || ""
								return (
									<th
										key={`${column.accessor}${index}`}
										data-key={`${column.accessor}${index}`}
										className={`${additionalClasses}`}
									>
										{!column?.className.includes("action-container") && (
											<LabelContainer
												isLoading={isLoading}
												className={`label-container ${isSorted} ${isSortable} ${additionalClasses}`}
												{...column.getHeaderProps(
													column.getSortByToggleProps()
												)}
											>
												{column?.TableHeader && column.render("TableHeader")}
												<span className="label">{column.render("header")}</span>
												{column.disableSortBy ? null : column.isSortedDesc ? (
													<Icon icon={SortRegular} size="16px" />
												) : (
													<Icon icon={SortUpRegular} size="16px" />
												)}
											</LabelContainer>
										)}
									</th>
								)
							})}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
					{rows.map(row => {
						rowUniqKey = ++rowUniqKey
						prepareRow(row)
						return (
							<tr key={`row-${rowUniqKey}`} {...row.getRowProps(rowProps(row))}>
								{row.cells.map((cell: any) => {
									cellUniqKey = ++cellUniqKey
									return (
										<td
											key={`cell-${cellUniqKey}`}
											className={cell.column.className}
											{...cell.getCellProps()}
										>
											<div className="content">{cell.render("Cell")}</div>
										</td>
									)
								})}
							</tr>
						)
					})}
				</tbody>
			</table>
		</TableContainer>
	)
}

export default Table
